import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  beneficiaryDetails: {
    primaryAccountHolder: boolean;
    patientName: string;
    patientId: number;
    isMinor: boolean;
    dateOfBirth: string;
  }[];
  newUploadData: {
    claimId: number;
    beneficiarySelected: string | null;
    dateOfService: string | null;
    procedureLabel: string | null;
    providerName: string | null;
    totalChargeAmount: number;
    isMinor: boolean;
    primaryAccountHolder: boolean;
    patientId: number;
  };
  error: boolean;
  loading: boolean;
  errorMessage: string;
} = {
  beneficiaryDetails: [
    {
      primaryAccountHolder: false,
      patientName: "",
      patientId: 0,
      isMinor: false,
      dateOfBirth: "",
    },
  ],
  newUploadData: {
    claimId: 0,
    beneficiarySelected: "",
    dateOfService: "",
    procedureLabel: "",
    providerName: "",
    totalChargeAmount: 0,
    isMinor: false,
    primaryAccountHolder: false,
    patientId: 0,
  },
  error: false,
  loading: false,
  errorMessage: "",
};
const bbNewUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_NEW_UPLOAD:
      return {
        ...state,
        newUploadData: { ...action.newUploadData },
      };
    case actionTypes.FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_STARTED: {
      return updateObject(state, {
        loading: true,
        beneficiaryDetails: initialState.beneficiaryDetails,
        error: false,
        errorMessage: "",
      });
    }
    case actionTypes.FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_SUCCESS: {
      return updateObject(state, {
        beneficiaryDetails: action.beneficiaryDetails,
        error: false,
        errorMessage: "",
        loading: false,
      });
    }
    case actionTypes.FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_FAILED:
      return updateObject(state, {
        beneficiaryDetails: initialState.beneficiaryDetails,
        error: true,
        errorMessage: action.errorMessage,
        loading: false,
      });
    default:
      return state;
  }
};
export default bbNewUploadReducer;
